/**
 * 
 */
(function(undefined) {
	"use strict";
	angular
			.module("cbl.finanza.mf.directives")
			.service(
					"FinUploadSrvc",
					[
							'$q',
							'$http',
							'FinMessaggiFctr',
							'FinLabelSrvc',
							'FIN_CONSTANTS',
							function($q, $http, messaggiFctr, labelSrvc, CONSTANTS) {
								this.upload = null;
								var root = this;

								this.getTipo = function(codice) {
									var defer = $q.defer();
									if (this.tipo) {
										defer.resolve(this.tipo);
									} else {
										var self = this;
										$http({
											method : "GET",
											url : CONSTANTS.REST_ROOT + CONSTANTS.REST.TIPO_DOCUMENTO,
											params : {
												categoria : codice
											}
										}).then(function(response) {
											if (messaggiFctr.processaResponse(response)) {
												return;
											}
											defer.resolve(response);
										}, function(reason) {
											messaggiFctr.processaResponse(reason);
											defer.reject(reason);
										});
									}
									return defer.promise;
								};

								// Converte la stringa di dati a 64 bit in byteArrays
								this.b64toByteArrays = function(b64Data, sliceSize) {
									sliceSize = sliceSize || 512;
									var byteCharacters = atob(b64Data);
									var byteArrays = [];

									for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
										var slice = byteCharacters.slice(offset, offset + sliceSize);

										var byteNumbers = new Array(slice.length);
										for (var i = 0; i < slice.length; i++) {
											byteNumbers[i] = slice.charCodeAt(i);
										}

										var byteArray = new Uint8Array(byteNumbers);

										byteArrays.push(byteArray);
									}
									return byteArrays;
								};

								// Genera un oggetto di tipo Blob (per IE) o di tipo File e fa partire il download
								this.download =
										function(strData, fileName) {
											var byteArrays = this.b64toByteArrays(strData);

											var isChromium = window.chrome, winNav = window.navigator, vendorName = winNav.vendor, isOpera = winNav.userAgent.indexOf("OPR") > -1, isIEedge =
													winNav.userAgent.indexOf("Edge") > -1, isIOSChrome = winNav.userAgent.match("CriOS");
											var blob = null;
											var blobUrl = null;
											if (isIOSChrome ||
												(isChromium !== null && isChromium !== undefined && vendorName === "Google Inc." && isOpera === false && isIEedge === false)) {
												// Google Chrome
												blob = new Blob(byteArrays, {
													type : 'application/octet-stream'
												});
												blobUrl = URL.createObjectURL(blob);
												// soluzione per costringere chrome a mostrare nome ed estensione del file
												var a = document.createElement("a");
												document.body.appendChild(a);
												a.style = "display: none";
												a.href = blobUrl;
												a.download = fileName;
												a.click();
												window.URL.revokeObjectURL(fileUrl);
												a.parentNode.removeChild(a);
											} else {
												// non Google Chrome
												// Blob per internet explorer
												if (navigator.msSaveOrOpenBlob) {
													blob = new Blob(byteArrays, {
														type : 'application/octet-stream'
													});
													blobUrl = URL.createObjectURL(blob);
													navigator.msSaveOrOpenBlob(blob, fileName);
												} // File per altri browser
												else {
													var file = new File(byteArrays, fileName, {
														type : 'application/octet-stream;'
													});
													var fileUrl = URL.createObjectURL(file);
													window.open(fileUrl);
												}
											}
										};

								this.getFile = function(idViacart, fileName) {
									var defer = $q.defer();
									$http({
										method : "GET",
										url : CONSTANTS.REST_ROOT + CONSTANTS.REST.UPLOAD_DOCUMENTO,
										params : {
											idViacart : idViacart
										}
									}).then(function(response) {
										if (messaggiFctr.processaResponse(response)) {
											defer.reject(response);
										}
										root.download(response.data.result.data, fileName, response.data.result.extension);
										defer.resolve(response);
									}, function(reason) {
										messaggiFctr.processaResponse(reason);
										defer.reject(reason);
									});
									return defer.promise;
								};

								this.reset = function() {
									this.upload = null;
								};

							} ]);
}());


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finUpload/finUploadSrvc.js
 ** module id = 47
 ** module chunks = 1
 **/